import axios from 'axios';

export const getCountryFeatures = async (countryCode) => {
  try {
    const response = await axios.get(`/country/${countryCode}/features`);
    return response?.data;
  } catch {
    return [];
  }
};
